import React from "react";
import { connect } from "react-redux";

// import DesignRules from './DesignRules';

import { Message } from "semantic-ui-react";
import {
  setPageTitle,
  toggleNavigation,
  setMessage,
  setBreadCrum,
  toggleBreadcrum,

} from "../../../store/Page";

import DatatableList from "./DatatableList";
import DatatableListForTranScript from "../TranscriptChat/DatatableList"
import './ChatAttachement.css';
import DataTableLisForAIPhone from "../AI Phones/DataTableList";
import { selectIsPLGAccount } from "../../../store/userSelectors";
import WatchPageTutorial from "../../CommonComponents/WatchPageTutorial";
const queryString = require("query-string");

class CompletedChats extends React.Component {
  constructor(props) {
    super(props);

    // PLG accounts show only Inbound Calls tab
    const isPlg = props.isPLG;

    this.state = {
      activetab: "design",
      userToaster: false,
      userToasterMsg: "",
      userToasterColor: "",
      cchat: isPlg ? '' : 'active',
      tchat:'',
      vchat: isPlg ? 'active' : '',
      ochat: '',
      smschat: ''
    };
  }
  componentDidMount() {
    const {
      setPageTitle,
      toggleNavigation,
      location,
      toggleBreadcrum,
      PageMessage,
      setMessage,
      setBreadCrum,
    } = this.props;
    setPageTitle({ title: "Your Interactions",subHeaderTitle:'Conversations' });
    

    toggleNavigation({ toggle: true });
    toggleBreadcrum({ toggle: false });
    const params = queryString.parse(location.search);

    if (params && params.tab !== undefined) {
      this.setState({
        activetab: params.tab,
      });
    }
  }

  toggleTab = (tab) => {
    if (tab === "cchat") {
      this.setState({
        cchat: "active",
        tchat: "",
        vchat: "",
        ochat: ""
      });
    } else if (tab === "tchat") {
      this.setState({
        cchat: "",
        tchat: "active",
        vchat: "",
        ochat: ""
      });
    } else if (tab === "vchat") {
      this.setState({
        cchat: "",
        tchat: "",
        vchat: "active",
        ochat: "",
        smschat: ""
      });
    } else if (tab === "ochat") {
      this.setState({
        cchat: "",
        tchat: "",
        vchat: "",
        ochat: "active",
        smschat: ""
      });
    } else if (tab === "smschat") {
      this.setState({
        cchat: "",
        tchat: "",
        vchat: "",
        ochat: "",
        smschat: "active"
      });
    }
  };

  render() {
    const isPlg = this.props.isPLG;

    return (
      <div
        className="kt-container kt-body  kt-grid kt-grid--ver completedchatmain completedchatmaintestingbot"
        id="kt_body"
      >
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
          <div className="kt-content kt-grid__item kt-grid__item--fluid yr-body-p">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div
                  className="kt-portlet kt-portlet--mobile"
                  style={{ boxShadow: "none" }}
                >
                  <div class="kt-portlet kt-portlet--tabs yr-mt-20 shadow-none">
                <div className="kt-portlet__head watch-page-tutorial-head">
                      <div className="kt-portlet__head-toolbar">
                        <ul
                          className="nav nav-tabs nav-tabs-line nav-tabs-line-success nav-tabs-line-3x"
                          role="tablist"
                        >
                          {!isPlg && (
                            <li className="nav-item">
                              <a
                                className={"nav-link " + this.state.cchat}
                                data-toggle="tab"
                                role="tab"
                                onClick={() => this.toggleTab("cchat")}
                                style={{ cursor: "pointer" }}
                              >
                                Automated Chats
                              </a>
                            </li>
                          )}

                          {!isPlg && (
                            <li className="nav-item">
                              <a
                                className={"nav-link " + this.state.tchat}
                                data-toggle="tab"
                                style={{ cursor: "pointer" }}
                                role="tab"
                                onClick={() => this.toggleTab("tchat")}
                              >
                                Live Chats
                              </a>
                            </li>
                          )}

                          <li className="nav-item">
                            <a
                              className={"nav-link " + this.state.vchat}
                              data-toggle="tab"
                              style={{ cursor: "pointer" }}
                              role="tab"
                              onClick={() => this.toggleTab("vchat")}
                            >
                              Inbound Calls
                            </a>
                          </li>

                          {!isPlg && (
                            <>
                              <li className="nav-item">
                                <a
                                  className={"nav-link " + this.state.ochat}
                                  data-toggle="tab"
                                  style={{ cursor: "pointer" }}
                                  role="tab"
                                  onClick={() => this.toggleTab("ochat")}
                                >
                                  Outbound Calls
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={"nav-link " + this.state.smschat}
                                  data-toggle="tab"
                                  style={{ cursor: "pointer" }}
                                  role="tab"
                                  onClick={() => this.toggleTab("smschat")}
                                >
                                  Outbound SMS
                                </a>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                      <WatchPageTutorial
                        videoKey="profile"
                        className="watch-page-tutorial--inline-tab"
                      />
                    </div></div>
                  <div className="kt-portlet__body kt-portlet__body--fit">
                  <div className="tab-content">
                        {!isPlg && (
                          <div
                            className={"tab-pane " + this.state.cchat}
                            id="kt_portlet_base_demo_1_1_tab_content"
                            role="tabpanel"
                          >
                            <DatatableList user={this.props.user} />
                          </div>
                        )}

                        {!isPlg && (
                          <div
                            className={"tab-pane " + this.state.tchat}
                            id="tranScriptChatList"
                            role="tabpanel"
                          >
                            <DatatableListForTranScript user={this.props.user} />
                          </div>
                        )}

                    <div
                      className={"tab-pane " + this.state.vchat}
                      id="tranScriptChatList"
                      role="tabpanel"
                    >
                      <DataTableLisForAIPhone user={this.props.user} call_type="inbound" isPLG={this.props.isPLG} />
                    </div>

                    {!isPlg && (
                      <div
                        className={"tab-pane " + this.state.ochat}
                        id="tranScriptChatList"
                        role="tabpanel"
                      >
                        <DataTableLisForAIPhone user={this.props.user} call_type="outbound" isPLG={this.props.isPLG} />
                      </div>
                    )}

                    {!isPlg && (
                      <div
                        className={"tab-pane " + this.state.smschat}
                        id="smsCampaignList"
                        role="tabpanel"
                      >
                        <DataTableLisForAIPhone user={this.props.user} call_type="sms" isPLG={false} />
                      </div>
                    )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    PageMessage: state.page.message,
    user: state.user.company ? state.user.company : null,
    isPLG: selectIsPLGAccount(state),  // Get PLG status directly!
  };
};
export default connect(mapStateToProps, {
  setPageTitle,
  toggleNavigation,
  setMessage,
  setBreadCrum,
  toggleBreadcrum
})(CompletedChats);
